import * as React from 'react';
import { Icon } from '../icon/icon';

export const IconApple: React.FC = () => (
    <Icon viewBox="0 0 41 50" fill="none">
        <path
            d="M33.777 26.5038C33.715 20.2718 38.859 17.2828 39.089 17.1318C36.198 12.9048 31.694 12.3248 30.091 12.2588C26.261 11.8698 22.614 14.5148 20.671 14.5148C18.732 14.5148 15.73 12.3158 12.554 12.3718C8.376 12.4338 4.525 14.8018 2.375 18.5418C-1.964 26.0688 1.265 37.2238 5.493 43.3328C7.56 46.3188 10.025 49.6788 13.259 49.5558C16.376 49.4328 17.552 47.5398 21.32 47.5398C25.088 47.5398 26.146 49.5558 29.443 49.4928C32.795 49.4318 34.92 46.4498 36.97 43.4518C39.343 39.9828 40.32 36.6238 40.378 36.4538C40.305 36.4198 33.844 33.9448 33.777 26.5038Z"
            fill="currentColor"
        />
        <path
            d="M27.582 8.21584C29.297 6.13384 30.459 3.24084 30.143 0.36084C27.668 0.46084 24.672 2.00584 22.895 4.08584C21.303 5.93184 19.911 8.87084 20.284 11.6988C23.045 11.9128 25.861 10.2938 27.582 8.21584Z"
            fill="currentColor"
        />
    </Icon>
);
